import { types, flow } from "mobx-state-tree";
import api from "../../services/api";
import JsonType from "@viewStore/JsonType";

export const StateStore = types
    .model({
        user: types.optional(JsonType, []),

        apiToken:       types.optional(types.string, ""),
	    apiUri:         types.optional(types.string, "https://api-produtividade.hom.sms.fortaleza.ce.gov.br"),
        apiReportUrl:   types.optional(types.string, "https://reportserver.sms.fortaleza.ce.gov.br/jasperserver/flow.html?j_username=jasperadmin&j_password=jasperadmin&_flowId=viewReportFlow&_flowId=viewReportFlow&standAlone=true&output=pdf&ParentFolderUri=Relatórios/PRODUTIVIDADE/Dinâmicos&reportUnit=/Relatórios/PRODUTIVIDADE/Dinâmicos"),
        
        isAuthenticated: types.optional(types.boolean, false),
    })  
    .actions(self=>({
        setAuthenticated(value){
            self.isAuthenticated = value;
        },

        setApiToken(value){
            self.apiToken = value;
        },

        setUser(value){
            self.user = value;
        },

        requestUser: flow(function* requestUser() {
            
            try {
                const json = yield  api.userInfo(self.apiUri, {
                    token: self.apiToken,
                });
                                  
                //console.log(json);              
                if (json.hasOwnProperty('id')) {
                    self.user = json;
                }
      
            } catch (error) {
                console.log(error.message);
                
                // self.error = error.message;    
            }
        }),

        download: flow(function* download(uri, reportFileName, params) {

            const blob = yield fetch(`${self.apiUri}/${uri}`, {
                ...params, headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${self.apiToken}`
                }
            }).then(res => res.blob())

            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', reportFileName)

            document.body.appendChild(link)

            link.click()
            link.remove()
        })

    }));

const Store = StateStore.create({});

export default Store;
